import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm, SmartTable, SmartTableNewInterface } from "soft_digi";

import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import { role_get_select } from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";
import { MODULES_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose } from "../../services/notifyService";


const AdminModuleAccess = () => {
  const { closeModal } = useSiteContext();
  const [tabData, setTabData] = useState([]);
  const [allRole, setAllRole] = useState([]);

  const {
    handleSubmit,
    watch,
    formState: { errors },
    control,
  } = useForm();

  const selectedRole = watch("role");

  useEffect(() => {
    if (selectedRole) {
      post(MODULES_URLS.GET_ALL_ROLE, { role: selectedRole }).subscribe(
        (response) => {
          setTabData(response.data);
        }
      );
    }
  }, [selectedRole]);

  useEffect(() => {
    role_get_select((data: any) => setAllRole(data));
  }, []);


  const onSubmit = (data: any) => {
    const formattedData = {
      role: data.role,
      sub_data: [...tabData],
    };

    post(MODULES_URLS.UPDATE, formattedData).subscribe(() => {
      showAlertAutoClose("Updated Successfully...", "success");
      closeModal();
    });
  };

  const handleCheckboxChange = (itemId: number, subId: number) => {
    setTabData((prevData: any) =>
      prevData.map((item: any) =>
        item.ID === itemId
          ? {
              ...item,
              sub_data: item.sub_data.map((sub: any) =>
                sub.ID === subId
                  ? { ...sub, value: sub.value == "1" ? "0" : "1" }
                  : sub
              ),
            }
          : item
      )
    );
  };

  let checkBoXColumns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [];
  let actions = ["add", "edit", "view", "approve"];
  actions.forEach((act) => {
    checkBoXColumns.push({
      title: act,
      index: act + "_action",
      width: "10",
      valueFunction: (row: any) => {
        let actionExists = row.sub_data?.find(
          (item: any) => item.action === act
        );
        //console.log("action exits ", actionExists);
        return actionExists ? (
          <input
            type="checkbox"
            checked={actionExists.value == "1" ? true : false}
            onChange={() => handleCheckboxChange(row.ID, actionExists.ID)}
          />
        ) : null;
      },
    });
  });

  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    { title: "Module Name", index: "module_name", width: "30" },
    ...checkBoXColumns,
   
  ];

  const elements: SdsFormElementProps[] = [
    {
      type: "SELECT_BOX",
      width: 4,
      name: "role",
      element: {
        label: "Role",
        inputType: "BORDER_LABEL",
        options: allRole,
      },
    },
  ];

  return (
    <>
      <div className="smart-hims-main-header">
        <p className="is-size-4 has-text-weight-bold mb-1">Module Access</p>
      </div>
      <div className="sd-hims-input mt-4">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
      {selectedRole && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mt-3">
          <SmartTable
            columns={columns}
            data={tabData}
            tableProps={{
              className: "is-hoverable is-bordered smart-efl-table",
              isResponsive: true,
              searchPlaceHolder: "Search",
            }}
            paginationProps={{
              pageSize: 30,
            }}
          /></div>
          <div className="has-text-right">
            <button type="submit" className="button is-primary">
              Save
            </button>
          </div>
        </form>
      )}
    </>
  );
};

export default AdminModuleAccess;
